import { TokenEventNames } from './TokenEventNames';
import { TokenRoutes } from './TokenRoutes';
import { TokenSessionStorageKeys } from './TokenSessionStorageKeys';
export const AUTHORIZATION_CODE_STORAGE_KEY = 'AuthCode';
// TODO: remove during refactor
/**
 * @deprecated use TokenSessionStorageKeys instead
 */
export const ANONYMOUS_TOKEN_STORAGE_KEY = 'PublicToken';
// TODO: remove during refactor
/**
 * @deprecated use TokenSessionStorageKeys instead
 */
export const USER_TOKEN_STORAGE_KEY = 'AuthToken';
export const ID_TOKEN_STORAGE_KEY = 'AuthIdToken';
export const AUTH_REDIRECT_URL_STORAGE_KEY = 'AuthRedirectUrl';
export const AUTH_REDIRECT_URI_STORAGE_KEY = 'AuthRedirectUri';
export const CODE_VERIFIER_STORAGE_KEY = 'AuthCodeVerifier';
export const AUTH_STATE_STORAGE_KEY = 'AuthState';
export const NONCE_STORAGE_KEY = 'AuthNonce';

/** User ID for user that is not logged in */
export const NOT_LOGGED_IN_USER_ID = -1;

/**
 * Identity server client ID for authentication.
 */
export const IDENTITY_CLIENT_ID = 'SPADev';

/**
 * Token configuration under token routes. This is mainly used in TokenClient to differentiate configuration between instances by route
 */
export const tokenConfigurationForTokenRoutes = {
  [TokenRoutes.PUBLIC_ACCESS]: {
    eventName: TokenEventNames.PUBLIC_ACCESS,
    sessionStorageKey: TokenSessionStorageKeys.PUBLIC_ACCESS
  },
  [TokenRoutes.USER_ACCESS]: {
    eventName: TokenEventNames.USER_ACCESS,
    sessionStorageKey: TokenSessionStorageKeys.USER_ACCESS
  }
};
//# sourceMappingURL=constants.js.map